import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TabDirective, TabsetComponent } from 'ngx-bootstrap/tabs';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-Awards',
    templateUrl: './Awards.component.html',
    styleUrls: ['./Awards.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AwardsComponent implements OnInit {

  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  id: number;
  tab = 'Achievements';
  enable = true;
  randomBool = true;

  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
  }

  constructor() { }

  onSelect(data: TabDirective): void {
    this.tab = data.heading();
    console.log('tab ' + this.tab);

  }

  ngOnInit() {
  }

}
